export const environment = {
  production: true,
  APIURL: "https://portal.cristie.com/portal/v1",
};
